module.exports = __webpack_public_path__ + "img/default.72416cbb.png";